import { combineReducers } from 'redux';
import zoneReducer from './containers/AreaCoverage/reducer';
import { reducer as formReducer } from 'redux-form';
import appReducer from './containers/Layouts/reducer';
import leadReducer from './containers/LeadManagement/reducer';
import companyReducer from './containers/CompanyProfile/reducer';
import branchReducer from './containers/Branches/reducer';
import userReducer from './containers/Users/reducer';
import preferencesReducer from './containers/Preferences/reducer';
import preferencesSetReducer from './containers/PreferenceSettings/reducer';
import apiAccessReducer from './containers/APIAccess/reducer';
import accountReducer from './containers/AccountDetails/reducer';
import gridReducer from './containers/GridProfile/reducer';
import thirdPartyReducer from './containers/ThirdPartyReporting/reducer';
import discountReducer from './containers/PlatformDiscounts/reducer';
import dashboardReducer from './containers/Dashboard/reducer';
import systemsReducer from './containers/Systems/reducer';
// import permitReducer from './containers/Permitting/reducer';
import sgipReducer from './containers/SGIPIncentive/reducer';
import einAdminReducer from './containers/EinAdmin/reducer';
import einDashboardReducer from './containers/EinDashboard/reducer';
import merchandiseReducer from './containers/MerchandiseCredit/reducer';
import leadPreferenceReducer from './containers/LeadPreferences/reducer';
import enlightenNoticeReducer from './containers/AdminNew/reducer';
import registrationReducer from './containers/Registration/reducer';
import authorizedDealer from './containers/AuthorizedDealer/reducer';
import generatorTokensReducer from './containers/GeneratorTokensInstaller/reducer';
import cellModemReducer from './containers/CellModemDataPlanExtension/reducer';
import generatorTokensDistributorReducer from './containers/GeneratorTokensDistributor/reducer';
import bomReducer from './containers/BOM/reducer';
import prontoReducer from './containers/Pronto/reducer'
import deviceReplacement from './containers/DeviceReplacement/reducer';

export default combineReducers({
  form: formReducer,
  zoneReducer,
  appReducer,
  leadReducer,
  companyReducer,
  branchReducer,
  userReducer,
  preferencesReducer,
  preferencesSetReducer,
  apiAccessReducer,
  accountReducer,
  gridReducer,
  thirdPartyReducer,
  discountReducer,
  dashboardReducer,
  systemsReducer,
  // permitReducer,
  sgipReducer,
  einAdminReducer,
  einDashboardReducer,
  merchandiseReducer,
  leadPreferenceReducer,
  enlightenNoticeReducer,
  registrationReducer,
  authorizedDealer,
  generatorTokensReducer,
  generatorTokensDistributorReducer,
  bomReducer,
  prontoReducer,
  cellModemReducer,
  deviceReplacement
});
